/** Open a data: URL in a new tab. Most browsers block direct navigation
 *  to data: URLs from a link click for security, so we convert it to a
 *  Blob URL on the fly. */
export const openDataUrl = (dataUrl: string) => {
  if (!dataUrl) return;
  try {
    const [head, body] = dataUrl.split(',');
    const mime = head.match(/data:([^;]+)/)?.[1] || 'image/png';
    const bin = atob(body || '');
    const len = bin.length;
    const buf = new Uint8Array(len);
    for (let i = 0; i < len; i++) buf[i] = bin.charCodeAt(i);
    const url = URL.createObjectURL(new Blob([buf], { type: mime }));
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 30_000);
  } catch (e) {
    console.error('Failed to open screenshot', e);
  }
};

/** Animated proof (a video story turned into a GIF / WebP) is kept as-is:
 *  re-encoding it through a canvas would keep only the first frame. */
export const isAnimatedPicture = (src: string): boolean => /^data:image\/(gif|webp)[;,]/.test(src);

export const readAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error ?? new Error('read failed'));
    reader.readAsDataURL(file);
  });

/** First frame of an animated picture as a JPEG — the PDF lookbook can only
 *  show JPEG/PNG. */
export const stillFrame = (src: string): Promise<string> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth || 1;
      canvas.height = img.naturalHeight || 1;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('canvas'));
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = () => reject(new Error('image load failed'));
    img.src = src;
  });
